interface VerifyInfo {
  user_id: string;
  show: boolean;
  challenge: any;
}
import { store, Vue } from "@/main";
import {
  GETTER_INS_USER_INFO_BY_ID,
  HANLDE_CHALLENGE
} from "@/store/constants/ins_user_info_types";
import HeadersCommon from "@/components/DlalogTsx/EarnCoins/HeadersCommon";
import { bloksApps, getChallenge } from "@/api/ins_api_new/apis/ins_challenge";
import { getCurrentRoute } from "@/plugins/navigation/routes";
import { INS_LOGIN_MSG } from "@/api/ins/base/ins_res_const";

class ShowInsVerify {
  private verifyList: VerifyInfo[] = [];
  private isShowing: boolean = false;

  public findVerifyList(id: string) {
    return this.verifyList.find(item => item.user_id === id);
  }

  public addVerifyInfo(info: VerifyInfo, not_show_now: boolean = false) {
    console.log(
      "addVerifyInfo",
      info,
      this.isShowing,
      "not_show_now",
      not_show_now
    );
    const findInfoIndex = this.findInfoExist(info.user_id);
    if (findInfoIndex < 0) {
      this.verifyList.push(info);
    }
    if (!this.isShowing && !not_show_now) {
      this.isShowing = true;
      this.showVerifyDialog(info.user_id, info.challenge);
    }
  }

  public showVerifyDialog(id: string, challenge: any) {
    try {
      const currentRoute = getCurrentRoute();
      if (
        !currentRoute.path.includes("Home") ||
        currentRoute.name === "ChallengePage"
      ) {
        this.isShowing = false;
        return;
      }
      const insUserInfo = store.getters[GETTER_INS_USER_INFO_BY_ID](id);
      if (insUserInfo) {
        const { ins_user_info } = insUserInfo;
        const { profile_pic_url, user_name } = ins_user_info;
        const _this = this;

        Vue.prototype.$_Dialog.show({
          title: "Verification Required",
          content: {
            text: `Dear @<%${user_name}/%>, for safety reason, your account needs to be verified before it could be used to continue earning more coins.`,
            highlightColor: "rgb(79, 121, 255)"
          },
          headerCustom(ctx: any, r: any) {
            return r(HeadersCommon, {
              props: {
                ctx,
                picUrl: profile_pic_url
              }
            });
          },
          closable: true,
          confirmBtn: {
            text: "Verify Now"
          },
          onModalCloseWithIcon(done: any) {
            done();
            _this.isShowing = false;
          },
          async onConfirm(done: any) {
            done();
            _this.isShowing = false;
            try {
              Vue.prototype.$_Toast.show({
                type: "loading",
                text: "Processing"
              });
              const verifyResult: any = await getChallenge(challenge, id, true);
              if (verifyResult && verifyResult.action === "close") {
                _this.deleteVerifyInfo(id);
                Vue.prototype.$_Toast.show({
                  text: "Verify Success"
                });
              }
              if (verifyResult.step_name) {
                const result = await bloksApps(
                  { ...verifyResult, get_challenge: true },
                  id
                );
                if (result.status === INS_LOGIN_MSG.INS_LOGIN_SUCCESS) {
                  _this.deleteVerifyInfo(id);
                  Vue.prototype.$_Toast.show({
                    text: "Verify Success"
                  });
                  return;
                }
                await store.dispatch(HANLDE_CHALLENGE, {
                  ...verifyResult,
                  login_user_id: id
                });
                _this.deleteVerifyInfo(id);
              }
              Vue.prototype.$_Toast.hide();
            } catch (error) {
              Vue.prototype.$_Toast.hide();
              console.log("onConfirm err", error);
              const { message, error_type }: any = error;
              Vue.prototype.$_Toast.show({
                text:
                  error_type === "show_toast"
                    ? message
                    : "Something is wrong with your account, please fix it in Instagram."
              });
            }
          }
        });
      }
    } catch (error) {
      this.isShowing = false;
      return Promise.reject(error);
    }
  }

  public deleteVerifyInfo(user_id: string) {
    const findInfoIndex = this.findInfoExist(user_id);
    if (findInfoIndex > -1) {
      this.verifyList.splice(findInfoIndex, 1);
    }
  }

  public findChallegeInfo(id: string) {
    return this.verifyList.find(item => item.user_id === id);
  }

  public findInfoExist(id: string) {
    return this.verifyList.findIndex(item => item.user_id === id);
  }
}

export default new ShowInsVerify();
